import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router';
import HomepageMountain from '../../../assets/images/homepage-mountain.jpg';
// Styles
import './homepage.scss';
import { ReleaseNotesList } from '../ReleaseNotes/ReleaseNotes';
import { LatestNewsList } from '../LatestNews/LatestNews';
import AppStore from 'cd-eft/models/Stores/AppStore';

const HomepageComponent = (props: any) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (AppStore.appConfig.useEAuth) {
      const queryParams = new URLSearchParams(location.search);
      if (queryParams.has('accessToken')) {
        // console.log('has access token');
        history.replace('/');
      }
    }
  }, []);

  return (
    <div className="homepage-container">
      <div className="homepage-main">
        <div className="hompage-image-layer"></div>
        <img src={HomepageMountain} alt="Homepage Mountains" width="600" height="400" />
        <div className="home-title" tabIndex={0}>
          <h1>Welcome to the</h1>
          <h1>
            <strong>NRCS Engineering Tool Suite</strong>
          </h1>
          <button
            className="usa-button usa-button--outline usa-button--inverse"
            aria-label="Read more"
            onClick={() => history.push('/about')}
          >
            Read More
          </button>
        </div>
      </div>
      <div className="homepage-banner" tabIndex={0}>
        <h2>
          NRCS Engineering Tool Suite (NETS) is a framework of design tools that gives field office individuals the
          ability to plan and design commonly applied conservation practices such as terraces, grassed waterways, water
          and sediment control basins, underground outlets, and several others. These tools provide the planner/designer
          the ability to perform computational analysis; create a complete design; create reports for design
          documentation and final construction; and export design elements and surfaces for final construction.
        </h2>
      </div>
      <div className="news-notes">
        <LatestNewsList />
        <ReleaseNotesList />
      </div>
    </div>
  );
};

export const Homepage = observer(HomepageComponent);
